import { render, staticRenderFns } from "./GroupTable.vue?vue&type=template&id=6223760f&scoped=true&"
import script from "./GroupTable.vue?vue&type=script&lang=js&"
export * from "./GroupTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupTable.vue?vue&type=style&index=0&id=6223760f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6223760f",
  null
  
)

export default component.exports